import React, { Component } from 'react';
import {Container,Grid} from 'semantic-ui-react';
import Content from './Content/Content';
// import Navbar from './Navbar/Navbar';
import Navmenu from './Navmenu';
import Footer from './Footer';
import '../App.css'

export default class Main extends Component {
   render() {
      return (
         <div>
            <Navmenu />
               <Container style={{width: '98%'}} className="main">
                  <Grid>
                     <Content />
                  </Grid>
               </Container>
            <Footer />
         </div>
      );
   }
}



// WEBPACK FOOTER //
// ./src/components/Main.js